import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Database = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Database' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M1,2 L23,2 L23,9 L1,9 L1,2 Z M4,12 L5,12 L5,13 L4,13 L4,12 Z M4,5 L5,5 L5,6 L4,6 L4,5 Z M4,19 L5,19 L5,20 L4,20 L4,19 Z M1,16 L23,16 L23,23 L1,23 L1,16 Z M1,9 L23,9 L23,16 L1,16 L1,9 Z' />
  </StyledIcon>
);
